import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { SalaryVerificationSettings } from '@/types/salaryVerification';
import { StepProgress } from './StepProgress';
import { PersonalInfoStep } from './PersonalInfoStep';
import { SubjectVerificationStep } from './SubjectVerificationStep';
import { AvailabilityVerificationStep } from './AvailabilityVerificationStep';

interface SalaryVerificationStepsProps {
  settings: SalaryVerificationSettings | null;
  teacherCode: string;
  onVerify: (data: any) => Promise<boolean>;
}

export function SalaryVerificationSteps({
  settings,
  teacherCode,
  onVerify
}: SalaryVerificationStepsProps) {
  const [currentStep, setCurrentStep] = useState(1);

  const handleStep1Complete = () => {
    setCurrentStep(2);
    window.scrollTo(0, 0);
  };

  const handleStep2Complete = () => {
    setCurrentStep(3);
    window.scrollTo(0, 0);
  };

  const handleStep3Complete = async (data: any) => {
    return await onVerify(data);
  };

  const handleBackToStep1 = () => {
    setCurrentStep(1);
    window.scrollTo(0, 0);
  };

  const handleBackToStep2 = () => {
    setCurrentStep(2);
    window.scrollTo(0, 0);
  };

  return (
    <Card className="p-6 border-amber-200 bg-amber-50">
      <div className="space-y-6">
        {/* Header */}
        <div className="text-center">
          <h3 className="text-lg font-semibold text-amber-800 mb-2">
            ยืนยันข้อมูลก่อนเข้าดูเงินเดือน
          </h3>
          {settings?.verification_message && (
            <p className="text-amber-700 text-sm">
              {settings.verification_message}
            </p>
          )}
        </div>

        {/* Step Progress */}
        <StepProgress currentStep={currentStep} />

        {/* Step Content */}
        {currentStep === 1 && (
          <PersonalInfoStep
            teacherCode={teacherCode}
            onComplete={handleStep1Complete}
          />
        )}

        {currentStep === 2 && (
          <SubjectVerificationStep
            teacherCode={teacherCode}
            onComplete={handleStep2Complete}
            onBack={handleBackToStep1}
          />
        )}

        {currentStep === 3 && (
          <AvailabilityVerificationStep
            teacherCode={teacherCode}
            onComplete={handleStep3Complete}
            onBack={handleBackToStep2}
          />
        )}
      </div>
    </Card>
  );
}
